var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23.3333 20V33.1333C23.4 33.6333 23.2333 34.1667 22.85 34.5167C22.2 35.1667 21.15 35.1667 20.5 34.5167L17.15 31.1667C16.7666 30.7833 16.6 30.2667 16.6666 29.7833V20H16.6166L7.01663 7.7C6.44997 6.98333 6.5833 5.93333 7.29997 5.36667C7.61663 5.13333 7.96663 5 8.3333 5H31.6666C32.0333 5 32.3833 5.13333 32.7 5.36667C33.4166 5.93333 33.55 6.98333 32.9833 7.7L23.3833 20H23.3333Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.56761c9fce7a8bd43c52bcae6c3c3dae.svg";
export { ForwardRef as ReactComponent };